import { render, staticRenderFns } from "./Prioritarias.vue?vue&type=template&id=2ab996c3&scoped=true"
import script from "./Prioritarias.vue?vue&type=script&lang=js"
export * from "./Prioritarias.vue?vue&type=script&lang=js"
import style0 from "./Prioritarias.vue?vue&type=style&index=0&id=2ab996c3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab996c3",
  null
  
)

export default component.exports